<template>
  <div id="poster-settings">
    <pui-common-spinner
      v-show="isLoading"
      :message="loadingMessage"
      fullscreen
      hideBackgroundCircle
    />
    <h1 class="settings-title">
      {{ $t('admin.poster.caches.title') }}
    </h1>
    <div class="settings-block-content">
      <pui-button @click="clearAllCaches" picto="mdi-sync">
        {{ $t('admin.poster.caches.clear.label') }}
      </pui-button>
    </div>
  </div>
</template>

<script>
import services from '../../../core/services';
import { getAdminService } from '../services';

export default {
  data() {
    return {
      isLoading: false,
      loadingMessage: '',
    };
  },
  methods: {
    /**
     * Start global loading (global spinner).
     * @param message : Loading message
     */
    startLoading(message) {
      this.loadingMessage = message;
      this.isLoading = true;
    },
    /**
     * Stop global loading.
     */
    stopLoading() {
      this.isLoading = false;
    },
    /**
     * Clear signage caches.
     */
    async clearAllCaches() {
      this.startLoading(this.$t('admin.poster.caches.clear.in_progress'));

      try {
        await getAdminService('cachesService').clearAllCaches();

        services.getService('alerts').alertSuccess(this.$t('admin.poster.caches.clear.success'));
      } catch (err) {
        // Do nothing
      }

      this.stopLoading();
    },
  },
};
</script>
